import { render, useEffect } from '@wordpress/element';

import './style.scss';
import Style from './Style';
import Counters from './Counters';
import { performCounter } from './Const/functions';

// Counters
document.addEventListener('DOMContentLoaded', () => {
	const allCounters = document.querySelectorAll('.wp-block-ctrb-counters');
	allCounters.forEach(counters => {
		const attributes = JSON.parse(counters.dataset.attributes);

		render(<RenderCounters attributes={attributes} counters={counters} />, counters);

		counters?.removeAttribute('data-attributes');
	});
});

const RenderCounters = ({ attributes, counters }) => {
	useEffect(() => {
		const counterEl = document.querySelectorAll(`#${counters.id} .ctrbCounters .counterNumber .number`);

		performCounter(counterEl, attributes.duration);
	}, []);

	return <>
		<Style attributes={attributes} clientId={attributes.cId} />

		<Counters attributes={attributes} />
	</>;
}